import { PackageIconSVG } from "../../../assets/SVGs/SVGs";

type Props = { data: any };

const PackageRow = ({ data }: Props) => {
  console.log(data, "PackageRowPackageRow");

  return (
    <div className="flex items-center w-full gap-4 px-4 py-2 rounded-lg shadow-md max-4xl:flex-col max-4xl:justify-between">
      <div className="flex items-center justify-start w-full gap-2 justify-self-start">
        {PackageIconSVG}
        <span className="text-sm font-semibold">Full Course {data?.name}</span>
      </div>
      <div className="flex items-center justify-between w-full gap-4">
        <div className="flex items-center gap-4">
          <div className="w-2 h-2 rounded-full bg-[#A9AEF6]" />
          <span className="text-sm text-color-primary">Hair</span>
          <div className="w-2 h-2 rounded-full bg-[#9999A7]" />
          <span className="text-sm text-color-primary">
            <span className="mx-1 font-semibold">{data?.services?.length}</span>
            <span className="text-[8px]">services</span>
          </span>
        </div>
        <div className="flex items-center gap-4">
          <div className="w-2 h-2 rounded-full bg-[#9999A7]" />
          <span className="text-sm text-color-primary">
            <span className="mx-1">{data?.total_time}</span>
            <span className="text-[8px]">mins</span>
          </span>
          <div className="w-2 h-2 rounded-full bg-[#9999A7]" />
          <span className="text-sm text-color-primary">
            <span className="mx-1">{data?.retail_price}</span>
            <span className="text-[8px]">SR</span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default PackageRow;
